import { useEffect, useRef, useState } from "react";

import { copyTextToClipboard } from "../../../../../../../util/copyToClipboard";
import { COPY_STATUS, getCopyTooltipLabel } from "./copyableInstanceNameUtils";

const RESET_DELAY_MILLISECONDS = 1500;

const CopyableInstanceName = ({ name }) => {
  const [status, setStatus] = useState(COPY_STATUS.IDLE);
  const resetTimeout = useRef(null);

  useEffect(() => () => clearTimeout(resetTimeout.current), []);

  const handleCopy = async () => {
    const copied = await copyTextToClipboard(name);
    setStatus(copied ? COPY_STATUS.COPIED : COPY_STATUS.FAILED);
    clearTimeout(resetTimeout.current);
    resetTimeout.current = setTimeout(
      () => setStatus(COPY_STATUS.IDLE),
      RESET_DELAY_MILLISECONDS,
    );
  };

  if (!name) return null;

  const tooltipLabel = getCopyTooltipLabel(status);
  const tooltipVisible = status !== COPY_STATUS.IDLE;

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label={`${name}. ${tooltipLabel}`}
      className="group relative cursor-copy rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
    >
      {name}
      <span
        role="status"
        className={`pointer-events-none absolute bottom-full left-1/2 z-10 mb-2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs font-normal text-white shadow transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100 ${
          tooltipVisible ? "opacity-100" : "opacity-0"
        }`}
      >
        {tooltipLabel}
      </span>
    </button>
  );
};

export default CopyableInstanceName;
